/* eslint-disable react/no-array-index-key */
import React from "react";
import { StyleSheet, View } from "react-native";
import S3Image from "screens/common/S3Image";
import { getFAImage } from "screens/Profile/utils";
import SCheckbox from "styled42/components/SCheckbox";
import SClickableArea from "styled42/components/SClickableArea";
import SText from "styled42/components/SText";

const splitIntoChunks = (arr = [], len) => {
  const chunks = [];
  const n = arr.length;
  let i = 0;
  while (i < n) {
    chunks.push(arr.slice(i, i += len));
  }
  return chunks;
}

const FAGrid = ({
  faList,
  selectedFAIds,
  onSelect,
  gridKey = "popular-grid"
}) => {
  const faGrid = splitIntoChunks(faList, 3);
  return (
    <View style={styles.container}>
      {faGrid.map((row, rowIndex) => (
        <View
          key={`row-${rowIndex}`}
          style={styles.faRow}
        >
          {row.map((item) => {
            const selected = selectedFAIds.indexOf(item.id) > -1;
            return (
              <SClickableArea
                key={`${gridKey}-${item.id}`}
                containerStyle={styles.faContainer}
                onClick={() => {
                  onSelect(item, selected, gridKey)
                }}
              >
                <SCheckbox
                  containerStyle={styles.faCheckbox}
                  checked={selected}
                />
                <S3Image
                  imageUrl={getFAImage(item.id)}
                  style={styles.faIcon}
                />
                <View style={styles.faTextContainer}>
                  <SText size={12} weight="400" color="#868594" align="center">
                    {item.name}
                  </SText>
                </View>
              </SClickableArea>
            );
          })}
        </View>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingVertical: 12,
    paddingHorizontal: 11
  },
  faRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center"
  },
  faContainer: {
    flex: 1,
    height: 114,
    margin: 5,
    padding: 8,
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "white",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#DBDBDB",
    borderRadius: 4,
    overflow: "hidden"
  },
  faCheckbox: {
    alignSelf: "flex-end"
  },
  faIcon: {
    width: 38,
    height: 38,
    borderRadius: 19
  },
  faTextContainer: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "center"
  }
});

export default FAGrid;